module.exports = __webpack_public_path__ + "img/34ebd34.png";